import { render, staticRenderFns } from "./MenuLateral.vue?vue&type=template&id=37166cfd"
import script from "./MenuLateral.vue?vue&type=script&lang=ts"
export * from "./MenuLateral.vue?vue&type=script&lang=ts"
import style0 from "./MenuLateral.vue?vue&type=style&index=0&id=37166cfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports